import { NavLink, Outlet } from "react-router-dom";

/**
 * Library — the consumption umbrella. Sub-tabs:
 *
 *   All        (default) — auto-composed and ENDLESS: pinned docs, latest, random,
 *                          tag spotlights, a Bhagavad Gītā card, recent videos
 *   Introduction          — guides to reading the Library itself (how our
 *                           texts are marked and recited); components/guide/
 *   Documents             — browse all published documents, filter by tag
 *   Videos                — channel videos AND the series they belong to. A
 *                           series is a way of grouping videos, not a separate
 *                           kind of thing, and giving it its own tab made the
 *                           reader choose between two doors to the same room.
 *   Resources             — curated index of external study sites
 *
 * Every authenticated role gets `library.view`.
 */

const TABS: ReadonlyArray<{ to: string; label: string; end?: boolean }> = [
  { to: "/dashboard/library", label: "All", end: true },
  { to: "/dashboard/library/introduction", label: "Introduction" },
  { to: "/dashboard/library/documents", label: "Documents" },
  { to: "/dashboard/library/videos", label: "Videos" },
  { to: "/dashboard/library/resources", label: "Resources" },
];

export default function LibraryLayout() {
  return (
    <div className="container-edit">
      <header className="mb-6">
        <p className="page-eyebrow mb-1.5">Library</p>
        <h1 className="page-title">
          Read, watch, <span className="font-display-italic">return</span>.
        </h1>
        <p className="font-grotesk text-[0.78rem] text-[var(--color-ink-soft)] mt-2 max-w-[58ch]">
          Documents, recordings, classes, and a curated index of the wider
          Sanskrit and Vedic study world. The umbrella for everything you
          can come back to.
        </p>
      </header>

      <nav
        className="flex flex-wrap gap-x-4 gap-y-2 border-b border-[var(--color-rule)] mb-7"
        aria-label="Library sections"
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) => `subtab ${isActive ? "is-active" : ""}`}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
